// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/ClashGrotesk-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/ClashGrotesk-Medium.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --clr-bg-card-light: #343963;
  --clr-bg-card-dark: #1c1f35;
  --clr-text-primary: #d8d9ed;
  --clr-text-secondary: #babcd9;
  --clr-divider: #6569c8;
}

@font-face {
  font-family: 'ClashGrotesk';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  font-weight: 400;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: 'ClashGrotesk';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
  font-weight: 500;
  font-display: swap;
  font-style: normal;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  -moz-text-size-adjust: none;
  -webkit-text-size-adjust: none;
  text-size-adjust: none;
  scroll-behavior: smooth;
}

body,
h1,
h2,
h3,
h4,
p,
figure,
blockquote,
dl,
dd {
  margin-block-end: 0;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'ClashGrotesk', sans-serif;
  min-height: 100vh;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  font-size-adjust: 0.52;
  background: linear-gradient(
    12deg,
    rgba(25, 28, 69, 1) 30%,
    rgba(35, 40, 95, 0.9) 70%,
    rgba(43, 49, 120, 0.75) 90%,
    rgba(62, 69, 171, 0.9) 109.2%
  );
}

h1,
h2,
h3,
h4,
button,
input,
label {
  line-height: 1.1;
}

h1,
h2,
h3,
h4 {
  text-wrap: balance;
  margin: 0;
}

p {
  text-wrap: pretty;
  margin: 0;
}

p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

img,
picture {
  max-width: 100%;
  display: block;
}

button {
  border: none;
  cursor: pointer;
  text-transform: uppercase;
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
}

input,
button,
textarea,
select {
  font-family: inherit;
  font-size: inherit;
}

:target {
  scroll-margin-block: 5ex;
}

@media (prefers-reduced-motion: no-preference) {
  html {
    interpolate-size: allow-keywords;
  }
}


.content-wrapper {
  min-height: 100vh;
  min-height: 100svh;
}

.header {
  margin: 1rem 0 3rem;

  .logo {
    width: 3rem;
  }

  .header-wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  .temperature-toggle {
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-self: end;

    .temp-label {
      font-family: 'Inter', sans-serif;
      font-weight: 600;
      color: #9396ce;
      font-size: 1.125rem;

      &.active {
        color: white;
      }
    }

    .toggle-btn {
      position: relative;
      width: 4rem;
      height: 2.5rem;
      background: #42457b;
      border: 1px solid var(--clr-divider);
      border-radius: 9999px;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.05);
      cursor: pointer;
      transition: all 0.3s ease;
    }

    .toggle-slider {
      position: absolute;
      top: 0.15rem;
      left: 0.25rem;
      width: 2rem;
      height: 2rem;
      background: #9396ce;
      border-radius: 50%;
      transition: all 0.3s ease;
    }

    .toggle-btn.active .toggle-slider {
      left: 1.625rem;
    }

    .toggle-btn:not(.active) .toggle-slider {
      left: 0.25rem;
    }
  }

  .search-wrapper {
    position: relative;
    margin-top: 2.25rem;
    grid-row: 2;
    grid-column: span 2;
    width: 100%;

    .search-icon {
      position: absolute;
      left: 1rem;
      top: 0.75rem;
    }

    .search-input {
      padding: 1rem 1rem 0.75rem 3rem;
      background: #42457b;
      border: 1px solid var(--clr-divider);
      height: 3rem;
      width: 100%;
      border-radius: 999px;
      color: #fff;
      font-weight: 500;
      font-size: 1.125rem;

      &::placeholder {
        font-size: 1.125rem;
        color: #9396ce;
        font-weight: 500;
      }

      &:focus {
        outline: 2px solid var(--clr-divider);
      }

      &::-webkit-search-cancel-button {
        filter: brightness(0) saturate(100%) invert(100%);
      }
    }

    .autocomplete-results {
      height: 0;
      overflow: hidden;
      position: absolute;
      width: 100%;
      transition: height 0.4s ease-out;

      &.open {
        height: auto;
        
        > ul {
          border: 1px solid var(--clr-divider);
          border-top: none;
        }
      }
      > ul {
        display: grid;
        color: var(--clr-text-primary);
        border-radius: 1.25rem;
        overflow: hidden;

        li {
          padding-left: 2rem;
          padding-block: 0.75rem;
          cursor: pointer;
          background: var(--clr-bg-card-light);

          &:hover {
            background: var(--clr-bg-card-dark);
          }
        }
      }
    }
  }
}

.container {
  width: 100%;
  padding: 0 16px;
  margin-inline: auto;
}

.location {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.25rem;

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }

  h3 {
    color: var(--clr-text-primary);
    font-size: clamp(1.375rem, 1.239rem + 0.68vw, 1.75rem);
    font-weight: 500;
  }
}

.cards-highlight {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
  margin-bottom: 2.5rem;

  .card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    border-radius: 2rem;
    border: 1px solid var(--clr-divider);
    background: var(--clr-bg-card-light);
    padding: 0.75rem 0;
    font-size: clamp(1rem, 0.909rem + 0.45vw, 1.25rem);
    color: var(--clr-text-secondary);

    .digit {
      gap: 0.5rem;
    }

    .digit {
      display: flex;
      align-items: center;
      gap: 1rem;

      img,
      svg {
        width: 2rem;
        height: 2rem;
      }

      > p {
        font-family: 'Inter', sans-serif;
        color: var(--clr-text-primary);
        font-size: 2rem;
        font-weight: 700;
        line-height: normal;
      }
    }

    .bottom {
      display: inline-flex;
      align-items: center;
    }

    &:first-child {
      grid-column: span 2;
    }
  }
}

.weather-details {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  padding: 0 0.5rem;
  margin-bottom: 2.5rem;

  .weather-details-item {
    display: flex;
    gap: 0.75rem;
  }

  .text-info {
    p {
      color: var(--clr-text-secondary);
      font-size: 1rem;
      margin-bottom: 0.25rem;
    }

    span {
      color: var(--clr-text-primary);
      font-family: 'Inter', sans-serif;
      font-size: 1.25rem;
      font-weight: 700;
    }
  }
}

.hourly-forecast {
  overflow-x: auto;
  display: flex;
  gap: 0.5rem;
  margin-bottom: 2.5rem;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #1a1a2e;
    border-radius: 0.25rem;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 0.25rem;
  }

  .hour {
    display: flex;
    width: fit-content;
    min-width: 4.5rem;
    padding: 1rem;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    border-radius: 1rem;
    background: var(--clr-bg-card-dark);
    color: var(--clr-text-primary);
    margin-bottom: 2rem;

    img {
      width: 1.5rem;
      height: 1.5rem;
    }

    span {
      color: var(--clr-text-secondary);
    }
  }
}

.weekly-forecast {
  display: grid;
  gap: 0.25rem;
  margin-bottom: 2rem;

  > li {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    padding: 0.75rem 2.5rem 0.75rem;
    border-radius: 0.75rem;
    background: var(--clr-bg-card-light, #343963);
    color: var(--clr-text-primary);
    font-size: 1.125rem;

    .icon img {
      width: 1.25rem;
      height: 1.25rem;
    }

    .day {
      width: 2.5rem;
      font-weight: 500;
    }
  }
}

/* Tablets */
@media (min-width: 768px) {
  .container {
    max-width: 90%;
    padding: 0;
  }
}

/* Desktops */
@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }

  .header {
    margin: 1.75rem 0 5rem;

    .logo {
      width: 4rem;
    }

    .header-wrapper {
      display: grid;
      grid-template-columns: 1fr 32.5rem 1fr;
    }

    .temperature-toggle {
      grid-row: 1;
      grid-column: 3;
      .temp-label {
        font-size: 1.375rem;
      }
    }

    .search-wrapper {
      margin-top: 0;
      grid-row: 1;
      grid-column: 2;

      .search-input {
        padding: 0.75rem 1rem 0.75rem 3.5rem;
        height: 3.5rem;
        font-size: 1.25rem;

        &::placeholder {
          font-size: 1.25rem;
        }
      }

      .search-icon {
        top: 0.95rem;
      }
    }
  }

  .location {
    margin-bottom: 2.5rem;
    svg {
      width: 1.5rem;
      height: 1.5rem;
    }
  }

  .cards-highlight {
    display: flex;
    justify-content: space-between;
    gap: 0.75rem;

    .card {
      padding: 1.5rem 0;
      border-radius: 3.5rem;
      flex: 1;

      .digit {
        gap: 1rem;
        > p {
          font-size: 2.5rem;
        }
      }

      .digit {
        img,
        svg {
          width: 2.5rem;
          height: 2.5rem;
        }
      }

      &:first-child {
        grid-column: span 2;
      }
    }
  }

  .weather-details {
    grid-template-columns: repeat(5, 1fr);
    padding: 0;
    margin-bottom: 4rem;

    svg {
      transform: translateY(2px);
    }

    .text-info {
      p {
        font-size: 1.25rem;
        margin-bottom: 0.5rem;
      }
    }

    .weather-details-item {
      justify-content: center;
    }
  }

  .hourly-forecast {
    margin-bottom: 6rem;

    .hour {
      flex: 1 0 4.5rem;
      min-width: 4.5rem;
    }
  }

  .weekly-forecast {
    display: flex;
    justify-content: space-between;
    gap: 0.75rem;

    > li {
      flex: 1;
      display: grid;
      text-align: center;
      gap: 0.75rem;
      padding: 0.75rem;
      border-radius: 1rem;
      font-size: 1rem;

      .icon img {
        margin: 0 auto;
        width: 1.75rem;
        height: 1.75rem;
      }

      .day {
        width: initial;
        font-size: 1.25rem;
        font-weight: 400;
      }
    }
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,4DAAqE;EACrE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,4DAAoE;EACpE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;;;;;;;;;EAUE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,sBAAsB;EACtB;;;;;;GAMC;AACH;;AAEA;;;;;;;EAOE,gBAAgB;AAClB;;AAEA;;;;EAIE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;EAIE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;;AAGA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;;EAEnB;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;;IAEjB;MACE,gCAAgC;MAChC,gBAAgB;MAChB,cAAc;MACd,mBAAmB;;MAEnB;QACE,YAAY;MACd;IACF;;IAEA;MACE,kBAAkB;MAClB,WAAW;MACX,cAAc;MACd,mBAAmB;MACnB,oCAAoC;MACpC,qBAAqB;MACrB,2CAA2C;MAC3C,eAAe;MACf,yBAAyB;IAC3B;;IAEA;MACE,kBAAkB;MAClB,YAAY;MACZ,aAAa;MACb,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,kBAAkB;MAClB,yBAAyB;IAC3B;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,WAAW;;IAEX;MACE,kBAAkB;MAClB,UAAU;MACV,YAAY;IACd;;IAEA;MACE,+BAA+B;MAC/B,mBAAmB;MACnB,oCAAoC;MACpC,YAAY;MACZ,WAAW;MACX,oBAAoB;MACpB,WAAW;MACX,gBAAgB;MAChB,mBAAmB;;MAEnB;QACE,mBAAmB;QACnB,cAAc;QACd,gBAAgB;MAClB;;MAEA;QACE,qCAAqC;MACvC;;MAEA;QACE,iDAAiD;MACnD;IACF;;IAEA;MACE,SAAS;MACT,gBAAgB;MAChB,kBAAkB;MAClB,WAAW;MACX,gCAAgC;;MAEhC;QACE,YAAY;;QAEZ;UACE,oCAAoC;UACpC,gBAAgB;QAClB;MACF;MACA;QACE,aAAa;QACb,8BAA8B;QAC9B,sBAAsB;QACtB,gBAAgB;;QAEhB;UACE,kBAAkB;UAClB,sBAAsB;UACtB,eAAe;UACf,oCAAoC;;UAEpC;YACE,mCAAmC;UACrC;QACF;MACF;IACF;EACF;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;;EAEtB;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,sDAAsD;IACtD,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,qBAAqB;;EAErB;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,oCAAoC;IACpC,kBAAkB;IAClB,kDAAkD;IAClD,gCAAgC;;IAEhC;MACE,WAAW;IACb;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;;MAET;;QAEE,WAAW;QACX,YAAY;MACd;;MAEA;QACE,gCAAgC;QAChC,8BAA8B;QAC9B,eAAe;QACf,gBAAgB;QAChB,mBAAmB;MACrB;IACF;;IAEA;MACE,oBAAoB;MACpB,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,qBAAqB;;EAErB;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE;MACE,gCAAgC;MAChC,eAAe;MACf,sBAAsB;IACxB;;IAEA;MACE,8BAA8B;MAC9B,gCAAgC;MAChC,kBAAkB;MAClB,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,qBAAqB;;EAErB;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;IACpC,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,mCAAmC;IACnC,8BAA8B;IAC9B,mBAAmB;;IAEnB;MACE,aAAa;MACb,cAAc;IAChB;;IAEA;MACE,gCAAgC;IAClC;EACF;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;;EAEnB;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;IAC/B,sBAAsB;IACtB,6CAA6C;IAC7C,8BAA8B;IAC9B,mBAAmB;;IAEnB;MACE,cAAc;MACd,eAAe;IACjB;;IAEA;MACE,aAAa;MACb,gBAAgB;IAClB;EACF;AACF;;AAEA,YAAY;AACZ;EACE;IACE,cAAc;IACd,UAAU;EACZ;AACF;;AAEA,aAAa;AACb;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;;IAEtB;MACE,WAAW;IACb;;IAEA;MACE,aAAa;MACb,sCAAsC;IACxC;;IAEA;MACE,WAAW;MACX,cAAc;MACd;QACE,mBAAmB;MACrB;IACF;;IAEA;MACE,aAAa;MACb,WAAW;MACX,cAAc;;MAEd;QACE,oCAAoC;QACpC,cAAc;QACd,kBAAkB;;QAElB;UACE,kBAAkB;QACpB;MACF;;MAEA;QACE,YAAY;MACd;IACF;EACF;;EAEA;IACE,qBAAqB;IACrB;MACE,aAAa;MACb,cAAc;IAChB;EACF;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,YAAY;;IAEZ;MACE,iBAAiB;MACjB,qBAAqB;MACrB,OAAO;;MAEP;QACE,SAAS;QACT;UACE,iBAAiB;QACnB;MACF;;MAEA;QACE;;UAEE,aAAa;UACb,cAAc;QAChB;MACF;;MAEA;QACE,mBAAmB;MACrB;IACF;EACF;;EAEA;IACE,qCAAqC;IACrC,UAAU;IACV,mBAAmB;;IAEnB;MACE,0BAA0B;IAC5B;;IAEA;MACE;QACE,kBAAkB;QAClB,qBAAqB;MACvB;IACF;;IAEA;MACE,uBAAuB;IACzB;EACF;;EAEA;IACE,mBAAmB;;IAEnB;MACE,gBAAgB;MAChB,iBAAiB;IACnB;EACF;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,YAAY;;IAEZ;MACE,OAAO;MACP,aAAa;MACb,kBAAkB;MAClB,YAAY;MACZ,gBAAgB;MAChB,mBAAmB;MACnB,eAAe;;MAEf;QACE,cAAc;QACd,cAAc;QACd,eAAe;MACjB;;MAEA;QACE,cAAc;QACd,kBAAkB;QAClB,gBAAgB;MAClB;IACF;EACF;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[":root {\r\n  --clr-bg-card-light: #343963;\r\n  --clr-bg-card-dark: #1c1f35;\r\n  --clr-text-primary: #d8d9ed;\r\n  --clr-text-secondary: #babcd9;\r\n  --clr-divider: #6569c8;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'ClashGrotesk';\r\n  src: url('./assets/fonts/ClashGrotesk-Regular.woff2') format('woff2');\r\n  font-weight: 400;\r\n  font-display: swap;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'ClashGrotesk';\r\n  src: url('./assets/fonts/ClashGrotesk-Medium.woff2') format('woff2');\r\n  font-weight: 500;\r\n  font-display: swap;\r\n  font-style: normal;\r\n}\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml {\r\n  -moz-text-size-adjust: none;\r\n  -webkit-text-size-adjust: none;\r\n  text-size-adjust: none;\r\n  scroll-behavior: smooth;\r\n}\r\n\r\nbody,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\np,\r\nfigure,\r\nblockquote,\r\ndl,\r\ndd {\r\n  margin-block-end: 0;\r\n}\r\n\r\nul {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nbody {\r\n  font-family: 'ClashGrotesk', sans-serif;\r\n  min-height: 100vh;\r\n  line-height: 1.5;\r\n  -webkit-font-smoothing: antialiased;\r\n  font-size-adjust: 0.52;\r\n  background: linear-gradient(\r\n    12deg,\r\n    rgba(25, 28, 69, 1) 30%,\r\n    rgba(35, 40, 95, 0.9) 70%,\r\n    rgba(43, 49, 120, 0.75) 90%,\r\n    rgba(62, 69, 171, 0.9) 109.2%\r\n  );\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nbutton,\r\ninput,\r\nlabel {\r\n  line-height: 1.1;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4 {\r\n  text-wrap: balance;\r\n  margin: 0;\r\n}\r\n\r\np {\r\n  text-wrap: pretty;\r\n  margin: 0;\r\n}\r\n\r\np,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  overflow-wrap: break-word;\r\n}\r\n\r\nimg,\r\npicture {\r\n  max-width: 100%;\r\n  display: block;\r\n}\r\n\r\nbutton {\r\n  border: none;\r\n  cursor: pointer;\r\n  text-transform: uppercase;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n}\r\n\r\ninput,\r\nbutton,\r\ntextarea,\r\nselect {\r\n  font-family: inherit;\r\n  font-size: inherit;\r\n}\r\n\r\n:target {\r\n  scroll-margin-block: 5ex;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  html {\r\n    interpolate-size: allow-keywords;\r\n  }\r\n}\r\n\r\n\r\n.content-wrapper {\r\n  min-height: 100vh;\r\n  min-height: 100svh;\r\n}\r\n\r\n.header {\r\n  margin: 1rem 0 3rem;\r\n\r\n  .logo {\r\n    width: 3rem;\r\n  }\r\n\r\n  .header-wrapper {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .temperature-toggle {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 1rem;\r\n    justify-self: end;\r\n\r\n    .temp-label {\r\n      font-family: 'Inter', sans-serif;\r\n      font-weight: 600;\r\n      color: #9396ce;\r\n      font-size: 1.125rem;\r\n\r\n      &.active {\r\n        color: white;\r\n      }\r\n    }\r\n\r\n    .toggle-btn {\r\n      position: relative;\r\n      width: 4rem;\r\n      height: 2.5rem;\r\n      background: #42457b;\r\n      border: 1px solid var(--clr-divider);\r\n      border-radius: 9999px;\r\n      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.05);\r\n      cursor: pointer;\r\n      transition: all 0.3s ease;\r\n    }\r\n\r\n    .toggle-slider {\r\n      position: absolute;\r\n      top: 0.15rem;\r\n      left: 0.25rem;\r\n      width: 2rem;\r\n      height: 2rem;\r\n      background: #9396ce;\r\n      border-radius: 50%;\r\n      transition: all 0.3s ease;\r\n    }\r\n\r\n    .toggle-btn.active .toggle-slider {\r\n      left: 1.625rem;\r\n    }\r\n\r\n    .toggle-btn:not(.active) .toggle-slider {\r\n      left: 0.25rem;\r\n    }\r\n  }\r\n\r\n  .search-wrapper {\r\n    position: relative;\r\n    margin-top: 2.25rem;\r\n    grid-row: 2;\r\n    grid-column: span 2;\r\n    width: 100%;\r\n\r\n    .search-icon {\r\n      position: absolute;\r\n      left: 1rem;\r\n      top: 0.75rem;\r\n    }\r\n\r\n    .search-input {\r\n      padding: 1rem 1rem 0.75rem 3rem;\r\n      background: #42457b;\r\n      border: 1px solid var(--clr-divider);\r\n      height: 3rem;\r\n      width: 100%;\r\n      border-radius: 999px;\r\n      color: #fff;\r\n      font-weight: 500;\r\n      font-size: 1.125rem;\r\n\r\n      &::placeholder {\r\n        font-size: 1.125rem;\r\n        color: #9396ce;\r\n        font-weight: 500;\r\n      }\r\n\r\n      &:focus {\r\n        outline: 2px solid var(--clr-divider);\r\n      }\r\n\r\n      &::-webkit-search-cancel-button {\r\n        filter: brightness(0) saturate(100%) invert(100%);\r\n      }\r\n    }\r\n\r\n    .autocomplete-results {\r\n      height: 0;\r\n      overflow: hidden;\r\n      position: absolute;\r\n      width: 100%;\r\n      transition: height 0.4s ease-out;\r\n\r\n      &.open {\r\n        height: auto;\r\n        \r\n        > ul {\r\n          border: 1px solid var(--clr-divider);\r\n          border-top: none;\r\n        }\r\n      }\r\n      > ul {\r\n        display: grid;\r\n        color: var(--clr-text-primary);\r\n        border-radius: 1.25rem;\r\n        overflow: hidden;\r\n\r\n        li {\r\n          padding-left: 2rem;\r\n          padding-block: 0.75rem;\r\n          cursor: pointer;\r\n          background: var(--clr-bg-card-light);\r\n\r\n          &:hover {\r\n            background: var(--clr-bg-card-dark);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.container {\r\n  width: 100%;\r\n  padding: 0 16px;\r\n  margin-inline: auto;\r\n}\r\n\r\n.location {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  margin-bottom: 1.25rem;\r\n\r\n  svg {\r\n    width: 1.25rem;\r\n    height: 1.25rem;\r\n  }\r\n\r\n  h3 {\r\n    color: var(--clr-text-primary);\r\n    font-size: clamp(1.375rem, 1.239rem + 0.68vw, 1.75rem);\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n.cards-highlight {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 0.5rem;\r\n  margin-bottom: 2.5rem;\r\n\r\n  .card {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 0.75rem;\r\n    border-radius: 2rem;\r\n    border: 1px solid var(--clr-divider);\r\n    background: var(--clr-bg-card-light);\r\n    padding: 0.75rem 0;\r\n    font-size: clamp(1rem, 0.909rem + 0.45vw, 1.25rem);\r\n    color: var(--clr-text-secondary);\r\n\r\n    .digit {\r\n      gap: 0.5rem;\r\n    }\r\n\r\n    .digit {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 1rem;\r\n\r\n      img,\r\n      svg {\r\n        width: 2rem;\r\n        height: 2rem;\r\n      }\r\n\r\n      > p {\r\n        font-family: 'Inter', sans-serif;\r\n        color: var(--clr-text-primary);\r\n        font-size: 2rem;\r\n        font-weight: 700;\r\n        line-height: normal;\r\n      }\r\n    }\r\n\r\n    .bottom {\r\n      display: inline-flex;\r\n      align-items: center;\r\n    }\r\n\r\n    &:first-child {\r\n      grid-column: span 2;\r\n    }\r\n  }\r\n}\r\n\r\n.weather-details {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 1rem;\r\n  padding: 0 0.5rem;\r\n  margin-bottom: 2.5rem;\r\n\r\n  .weather-details-item {\r\n    display: flex;\r\n    gap: 0.75rem;\r\n  }\r\n\r\n  .text-info {\r\n    p {\r\n      color: var(--clr-text-secondary);\r\n      font-size: 1rem;\r\n      margin-bottom: 0.25rem;\r\n    }\r\n\r\n    span {\r\n      color: var(--clr-text-primary);\r\n      font-family: 'Inter', sans-serif;\r\n      font-size: 1.25rem;\r\n      font-weight: 700;\r\n    }\r\n  }\r\n}\r\n\r\n.hourly-forecast {\r\n  overflow-x: auto;\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  margin-bottom: 2.5rem;\r\n\r\n  &::-webkit-scrollbar {\r\n    height: 6px;\r\n  }\r\n\r\n  &::-webkit-scrollbar-track {\r\n    background: #1a1a2e;\r\n    border-radius: 0.25rem;\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    background: rgba(255, 255, 255, 0.2);\r\n    border-radius: 0.25rem;\r\n  }\r\n\r\n  .hour {\r\n    display: flex;\r\n    width: fit-content;\r\n    min-width: 4.5rem;\r\n    padding: 1rem;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    border-radius: 1rem;\r\n    background: var(--clr-bg-card-dark);\r\n    color: var(--clr-text-primary);\r\n    margin-bottom: 2rem;\r\n\r\n    img {\r\n      width: 1.5rem;\r\n      height: 1.5rem;\r\n    }\r\n\r\n    span {\r\n      color: var(--clr-text-secondary);\r\n    }\r\n  }\r\n}\r\n\r\n.weekly-forecast {\r\n  display: grid;\r\n  gap: 0.25rem;\r\n  margin-bottom: 2rem;\r\n\r\n  > li {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 1.25rem;\r\n    padding: 0.75rem 2.5rem 0.75rem;\r\n    border-radius: 0.75rem;\r\n    background: var(--clr-bg-card-light, #343963);\r\n    color: var(--clr-text-primary);\r\n    font-size: 1.125rem;\r\n\r\n    .icon img {\r\n      width: 1.25rem;\r\n      height: 1.25rem;\r\n    }\r\n\r\n    .day {\r\n      width: 2.5rem;\r\n      font-weight: 500;\r\n    }\r\n  }\r\n}\r\n\r\n/* Tablets */\r\n@media (min-width: 768px) {\r\n  .container {\r\n    max-width: 90%;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n/* Desktops */\r\n@media (min-width: 992px) {\r\n  .container {\r\n    max-width: 960px;\r\n  }\r\n\r\n  .header {\r\n    margin: 1.75rem 0 5rem;\r\n\r\n    .logo {\r\n      width: 4rem;\r\n    }\r\n\r\n    .header-wrapper {\r\n      display: grid;\r\n      grid-template-columns: 1fr 32.5rem 1fr;\r\n    }\r\n\r\n    .temperature-toggle {\r\n      grid-row: 1;\r\n      grid-column: 3;\r\n      .temp-label {\r\n        font-size: 1.375rem;\r\n      }\r\n    }\r\n\r\n    .search-wrapper {\r\n      margin-top: 0;\r\n      grid-row: 1;\r\n      grid-column: 2;\r\n\r\n      .search-input {\r\n        padding: 0.75rem 1rem 0.75rem 3.5rem;\r\n        height: 3.5rem;\r\n        font-size: 1.25rem;\r\n\r\n        &::placeholder {\r\n          font-size: 1.25rem;\r\n        }\r\n      }\r\n\r\n      .search-icon {\r\n        top: 0.95rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  .location {\r\n    margin-bottom: 2.5rem;\r\n    svg {\r\n      width: 1.5rem;\r\n      height: 1.5rem;\r\n    }\r\n  }\r\n\r\n  .cards-highlight {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: 0.75rem;\r\n\r\n    .card {\r\n      padding: 1.5rem 0;\r\n      border-radius: 3.5rem;\r\n      flex: 1;\r\n\r\n      .digit {\r\n        gap: 1rem;\r\n        > p {\r\n          font-size: 2.5rem;\r\n        }\r\n      }\r\n\r\n      .digit {\r\n        img,\r\n        svg {\r\n          width: 2.5rem;\r\n          height: 2.5rem;\r\n        }\r\n      }\r\n\r\n      &:first-child {\r\n        grid-column: span 2;\r\n      }\r\n    }\r\n  }\r\n\r\n  .weather-details {\r\n    grid-template-columns: repeat(5, 1fr);\r\n    padding: 0;\r\n    margin-bottom: 4rem;\r\n\r\n    svg {\r\n      transform: translateY(2px);\r\n    }\r\n\r\n    .text-info {\r\n      p {\r\n        font-size: 1.25rem;\r\n        margin-bottom: 0.5rem;\r\n      }\r\n    }\r\n\r\n    .weather-details-item {\r\n      justify-content: center;\r\n    }\r\n  }\r\n\r\n  .hourly-forecast {\r\n    margin-bottom: 6rem;\r\n\r\n    .hour {\r\n      flex: 1 0 4.5rem;\r\n      min-width: 4.5rem;\r\n    }\r\n  }\r\n\r\n  .weekly-forecast {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: 0.75rem;\r\n\r\n    > li {\r\n      flex: 1;\r\n      display: grid;\r\n      text-align: center;\r\n      gap: 0.75rem;\r\n      padding: 0.75rem;\r\n      border-radius: 1rem;\r\n      font-size: 1rem;\r\n\r\n      .icon img {\r\n        margin: 0 auto;\r\n        width: 1.75rem;\r\n        height: 1.75rem;\r\n      }\r\n\r\n      .day {\r\n        width: initial;\r\n        font-size: 1.25rem;\r\n        font-weight: 400;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .container {\r\n    max-width: 1140px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
